import React, { useState, useEffect } from 'react';
import Loader from '../Loader/Loader';
import Suplier from '../Suplier/Suplier';
import { Link } from 'react-router-dom';
import Count from '../Count/Count';
import '../../ModernTable.css';

const Supliers = ({ suppliers, load, SuplierRender, DeleteSup, setSuppliers }) => {

  if (load) {
    return <Loader />;
  }

  return (
    <div className="table-responsive">
      <table className='modern-table'>
        <thead>
          <tr>
            <th>Supplier Name</th>
            <th>Doc. Aty..</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {suppliers.map(supplier => (<tr key={supplier.id}>
            <td data-label="Supplier Name">
              <Link to={`/uploadedDocs/supplier?vid=${supplier.id}`} onClick={() => SuplierRender(supplier)}>
                {supplier.vendorName}
              </Link>
            </td>
            <td data-label="Doc. Aty.."><Count id={supplier.id} /></td>
            <td data-label="Action"><button className='btn-premium danger' onClick={() => DeleteSup(supplier.id)}>Delete</button></td>
          </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Supliers